export const DropDownMenuStyles = {
  menuOverlay: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 10,
    backgroundColor: 'rgba(0,0,0,0.2)'
  },
  menuWrapper: {
    position: 'relative',
    zIndex: 11,
  },
  menu: {
    position: 'absolute',
    minWidth: 150,
    backgroundColor: '#ffffff',
    padding: 10,
    top: 40,
    right: 0,
    zIndex: 12,
  },
  toggleButton: {
    position: 'relative',
    zIndex: 12
  },
  menuItem: {
    padding: '5px 0px',
    fontSize: 12
  },
  icon: {
    width: 25,
    fontSize: 16
  },
  optionText: {
    textAlign: 'right'
  }
}
